<spinner *ngIf="loading"></spinner>
<div class="container-fluid">
    <div class="d-flex justify-content-between align-items-center pb-3 patients-toolbar">
        <h4 class="mb-0 patients-heading">Admin Dashboard <i class="bi bi-caret-right-fill"></i></h4>
        <div class="d-flex align-items-center gap-2 patients-toolbar-actions">
            <!-- UNIVAPLAT-2551: Bulk actions entry point — disabled when the current filters match no users -->
            <div ngbDropdown class="d-inline-block">
                <button class="btn btn-gray" ngbDropdownToggle
                        [disabled]="pagination.totalCount === 0"
                        data-testid="bulk-actions-btn">
                    <i class="bi bi-send"></i> Bulk actions
                </button>
                <div ngbDropdownMenu>
                    <button ngbDropdownItem type="button" (click)="openBulkWhatsAppSend()" data-testid="bulk-actions-whatsapp-item">
                        Send WhatsApp template
                    </button>
                </div>
            </div>
            <button class="btn btn-gray" (click)="toggleFilters()">
                <i class="bi bi-funnel"></i> Filters
            </button>
        </div>
    </div>

    <!-- Filters Sidebar -->
    @if (showFilters) {
        <div class="filter-overlay" (click)="onFilterCancel()"></div>
        <div class="filter-sidebar" [class.open]="showFilters">
            <cdss-admin-dashboard-filter
                [(filter)]="filter"
                (apply)="onFilterApply()"
                (cancel)="onFilterCancel()">
            </cdss-admin-dashboard-filter>
        </div>
    }

    @if (!loading) {
        <!-- Table -->
        <overlay-spinner *ngIf="refreshing"></overlay-spinner>
        <div class="table-card mt-4">
        <ngx-datatable class="bootstrap" #table
                       [rows]="rows"
                       [columnMode]="'force'"
                       [headerHeight]='36'
                       [rowHeight]="'auto'"
                       [footerHeight]="0"
                       [limit]="pagination.size"
                       [messages]="{emptyMessage: 'No results found', totalMessage: 'records found'}"
                       (sort)="onSort($event)"
                       (activate)="onRowActivate($event)"
                       [scrollbarH]="false">

            <!-- UNIVAPLAT-3142: the wide 18-column table collapsed the identity
                 columns (First/Last Name, Type, Connected to) into one Patient
                 cell — avatar, name, inline connected-to, and a role badge —
                 and moved 8 lower-priority columns (Current Week, Adherence,
                 Email, Phone, Connected to again, First/Last Login, Org,
                 Service, Team) into an expandable ngx-datatable row detail so
                 management sees the highest-signal columns without horizontal
                 scroll, while every field stays one click away. -->
            <ngx-datatable-row-detail [rowHeight]="'auto'" #myDetailRow>
                <ng-template let-row="row" ngx-datatable-row-detail-template>
                    <div class="detail-lines">
                        <div class="detail-line">
                            <div><div class="dl-label">UUID</div><div class="dl-value">{{ row.id }}</div></div>
                            <div>
                                <div class="dl-label">Current Week</div>
                                <div class="progress-wrap" *ngIf="row.userCareProgramme; else noWeek">
                                    <div class="progress-track"><div class="progress-fill" [style.width.%]="(row.userCareProgramme.currentWeek / row.userCareProgramme.durationInWeeks) * 100"></div></div>
                                    <span class="progress-label">{{ row.userCareProgramme.currentWeek }} / {{ row.userCareProgramme.durationInWeeks }}</span>
                                </div>
                                <ng-template #noWeek><div class="dl-value">-</div></ng-template>
                            </div>
                            <div><div class="dl-label">License Status</div><div class="dl-value">
                                <span *ngIf="row.license" class="badge text-bg-success"
                                      data-testid="license-status-badge">Active</span>
                                <span *ngIf="isDeactivated(row)" class="badge text-bg-danger"
                                      data-testid="license-status-badge">Deactivated</span>
                                <span *ngIf="!row.license && !isDeactivated(row)">-</span>
                            </div></div>
                            <div><div class="dl-label">First Login</div><div class="dl-value">{{ row.firstLoginAt | date:'dd/MM/yyyy HH:mm' }}</div></div>
                            <div><div class="dl-label">Email</div><div class="dl-value">
                                <app-masked-field *ngIf="row.email" [value]="row.email" [targetUserId]="row.id" fieldName="email"></app-masked-field>
                                <span *ngIf="!row.email">-</span>
                            </div></div>
                            <div><div class="dl-label">Phone</div><div class="dl-value">
                                <app-masked-field *ngIf="row.phoneNumber" [value]="row.phoneNumber" [targetUserId]="row.id" fieldName="phoneNumber"></app-masked-field>
                                <span *ngIf="!row.phoneNumber">-</span>
                            </div></div>
                        </div>
                        <div class="detail-line">
                            <div><div class="dl-label">Connected to</div><div class="dl-value">
                                @if (row.patient?.id && row.role.role === 'Patient' && row.carer?.id) {
                                    <a [routerLink]="['/cdss/patient-overview', row.patient?.id]" [state]="{role: 'carer'}">
                                        <app-masked-field [value]="row.carer?.firstName + ' ' + row.carer?.lastName" [targetUserId]="row.carer?.id" fieldName="name"></app-masked-field>
                                    </a>
                                } @else if (row.patient?.id && row.role?.role === 'Carer' && row.patient?.firstName != '-') {
                                    <a [routerLink]="['/cdss/patient-overview', row.patient?.id]">
                                        <app-masked-field [value]="row.patient?.firstName + ' ' + row.patient?.lastName" [targetUserId]="row.patient?.id" fieldName="name"></app-masked-field>
                                    </a>
                                } @else {
                                    -
                                }
                            </div></div>
                            <div>
                                <div class="dl-label">Adherence</div>
                                <div class="progress-wrap" *ngIf="row.userCareProgramme; else noAdherence">
                                    <div class="progress-track"><div class="progress-fill" [style.width.%]="(row.userCareProgramme.modulesCompleted / row.userCareProgramme.numberOfModules) * 100"></div></div>
                                    <span class="progress-label">{{ row.userCareProgramme.modulesCompleted }} / {{ row.userCareProgramme.numberOfModules }}</span>
                                </div>
                                <ng-template #noAdherence><div class="dl-value">-</div></ng-template>
                            </div>
                            <div><div class="dl-label">Last Login</div><div class="dl-value">{{ row.lastLoginAt | date:'dd/MM/yyyy HH:mm' }}</div></div>
                            <div><div class="dl-label">Organisation</div><div class="dl-value">{{ row.organisation?.name || '-' }}</div></div>
                            <div><div class="dl-label">Service</div><div class="dl-value">{{ row.service?.name || '-' }}</div></div>
                            <div><div class="dl-label">Team</div><div class="dl-value">{{ row.department?.name || '-' }}</div></div>
                        </div>
                    </div>
                </ng-template>
            </ngx-datatable-row-detail>

            <ngx-datatable-column [flexGrow]="8.5" [minWidth]="240" name="User" [sortable]="false">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="name-cell">
                        <i class="bi bi-chevron-right chev"></i>
                        <span class="avatar">{{ (row.firstName || '?').charAt(0) }}{{ (row.lastName || '?').charAt(0) }}</span>
                        <div class="name-block">
                            <b class="name-line"><app-masked-field [value]="row.firstName + ' ' + row.lastName" [targetUserId]="row.id" fieldName="firstName"></app-masked-field></b>
                            <span class="badge b-type b-type-patient" *ngIf="row.role?.role == 'Patient'">{{ row.role?.role }}</span>
                            <span class="badge b-type b-type-carer" *ngIf="row.role?.role == 'Carer'">{{ row.role?.role }}</span>
                            @if (row.patient?.id && row.role.role === 'Patient' && row.carer?.id) {
                                <span class="connected-to"><i class="bi bi-arrow-return-right"></i> {{ row.carer?.firstName }} {{ row.carer?.lastName }} (Carer)</span>
                            } @else if (row.patient?.id && row.role?.role === 'Carer' && row.patient?.firstName != '-') {
                                <span class="connected-to"><i class="bi bi-arrow-return-right"></i> {{ row.patient?.firstName }} {{ row.patient?.lastName }} (Patient)</span>
                            }
                        </div>
                    </div>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="createdAt" name="Sign-up Date" [sortable]="true" [flexGrow]="0.3" [minWidth]="130">
                <ng-template let-row="row" ngx-datatable-cell-template>{{ row.createdAt | date:'dd/MM/yyyy' }}</ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="category" name="Customer Type" [sortable]="false" [flexGrow]="0.25" [minWidth]="110" [cellClass]="'text-center'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                <span [class.text-bg-primary]="row.category === 'NHS'" [class.text-bg-secondary]="row.category === 'DTC'">
                    {{ (row.category | uppercase) || '-' }}
                </span>
                </ng-template>
            </ngx-datatable-column>

            <!-- UNIVAPLAT-2772 / UNIVAPLAT-2757 (pass 3): row.license is the user's
                 ACTIVE license. A null license is ambiguous (deactivated OR never
                 licensed) — isDeactivated() disambiguates via the cached license
                 history (resolveLicenseStates). Active → green badge; deactivated
                 (null license + non-empty history) → red badge; never licensed or
                 still resolving → NO badge (the plan cell already shows '-'). -->
            <ngx-datatable-column prop="license" name="Plan Type" [sortable]="false" [flexGrow]="0.4" [minWidth]="90">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>{{ row.license?.name || '-' }}</span>
                </ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="careProgramme" name="Care Programme" [sortable]="false" [flexGrow]="3.8">
                <ng-template let-row="row" ngx-datatable-cell-template>{{ row.userCareProgramme?.careProgramme || '-' }}</ng-template>
            </ngx-datatable-column>

            <ngx-datatable-column prop="status" name="Status" [sortable]="false" [flexGrow]="0.2" [minWidth]="80" [cellClass]="'text-center'">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <span class="badge text-bg-neutral" *ngIf="row.status == 'draft'">{{(row.status | uppercase) || 'Unknown'}}</span>
                    <span class="badge text-bg-danger" *ngIf="row.status == 'not-logged-in'">NOT LOGGED IN</span>
                    <span class="badge text-bg-secondary" *ngIf="row.status == 'first-login-completed'">{{(row.status | uppercase) || 'Unknown'}}</span>
                    <span class="badge text-bg-warning" *ngIf="row.status == 'onboarding-completed'">{{(row.status | uppercase) || 'Unknown'}}</span>
                    <span class="badge text-bg-success" *ngIf="row.status == 'active'">{{(row.status | uppercase) || 'Unknown'}}</span>
                    <span class="badge text-bg-info" *ngIf="row.status == 'completed'">{{(row.status | uppercase) || 'Unknown'}}</span>
                </ng-template>
            </ngx-datatable-column>

            <!-- UNIVAPLAT-2574 follow-up: Engagement column so admins can SEE the
                 bucket(s) the filter narrows by. Labels come from
                 ADMIN_DASHBOARD_ENGAGEMENT_OPTIONS via the model's label lookup —
                 single source of truth shared with the filter dropdown.
                 UX refinement (2026-08-19): a user behind on 2+ weeks gets ONE
                 collapsed "<count> weeks not completed" badge whose ngbTooltip
                 lists the specific weeks (engagementBadges()); a single week
                 bucket — and the always-solo nicely_engaged / never_logged_in /
                 onboarding buckets — render as individual badges with no
                 tooltip (badge.tooltip is null, which keeps ngbTooltip disabled). -->
            <ngx-datatable-column prop="engagement" name="Engagement" [sortable]="false" [flexGrow]="1.9" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    @if (row.engagement?.length) {
                        <div class="d-flex flex-wrap gap-1">
                            @for (badge of engagementBadges(row.engagement); track badge.label) {
                                <span class="badge" [ngClass]="engagementBadgeClass(badge.value)"
                                      [ngbTooltip]="badge.tooltip">{{ badge.label }}</span>
                            }
                        </div>
                    } @else {
                        -
                    }
                </ng-template>
            </ngx-datatable-column>

            <!-- UNIVAPLAT-2757 (pass 3): the per-row license buttons collapsed into a
                 single kebab dropdown, so the column shrinks back to the icon-only
                 footprint (overview + WhatsApp + kebab). -->
            <!-- UNIVAPLAT-3142: restyled to the same stacked pill-button treatment
                 as dashboard-v2's OVERVIEW / MEED RISKS actions column, instead of
                 the bare icon row. The kebab dropdown's items are unchanged
                 (same data-testids) — just triggered from a full "ACTIONS" pill
                 formatted like the navbar's "My profile" menu. -->
            <ngx-datatable-column prop="actions" name="Action" [sortable]="false" [flexGrow]="1" [minWidth]="150">
                <ng-template let-row="row" ngx-datatable-cell-template>
                    <div class="d-flex flex-column gap-1 w-100">
                        <a class="btn btn-success btn-row-action d-flex justify-content-between align-items-center"
                           [routerLink]="['/cdss/patient-overview', row.patient?.id]">
                            <span>USER OVERVIEW</span>
                            <i class="bi bi-arrow-right"></i>
                        </a>
                        <!-- UNIVAPLAT-1925 + UNIVAPLAT-1951: WhatsApp Messaging — Patient & Carer rows -->
                        <a *ngIf="row.role?.role === 'Patient' || row.role?.role === 'Carer'"
                           class="btn btn-row-action btn-green d-flex justify-content-between align-items-center"
                           style="cursor: pointer;"
                           (click)="navigateToMessaging(row.id, row.phoneNumber)">
                            <span>SEND MESSAGE</span>
                            <i class="bi bi-arrow-right"></i>
                        </a>
                        <!-- UNIVAPLAT-2757 (pass 3): license actions collapsed into a single
                             dropdown (same ngbDropdown pattern as the bulk-actions menu
                             above), now surfaced as an ACTIONS pill instead of a kebab
                             icon. container="body" so ngx-datatable cells don't clip the
                             menu. Visibility per item:
                             - Deactivate: active license (UNIVAPLAT-2772)
                             - Edit reason / Reactivate: deactivated only — null license AND
                               non-empty history via isDeactivated() (UNIVAPLAT-2772/2773)
                             - History: every row (UNIVAPLAT-2774)
                             No frontend permission gate — backend enforces updateAdmin. -->
                        <div ngbDropdown container="body" class="d-block">
                            <button type="button"
                                    class="btn btn-secondary btn-row-action d-flex justify-content-between align-items-center w-100"
                                    ngbDropdownToggle
                                    aria-label="License actions"
                                    data-testid="license-actions-menu-btn">
                                <span>ACTIONS</span>
                                <i class="bi bi-arrow-right"></i>
                            </button>
                            <div ngbDropdownMenu>
                                <!-- UNIVAPLAT-2991: labelled Licenses group — same items and
                                     conditions as before, just headed now that the menu carries
                                     a second (OTP settings) group. -->
                                <h6 class="dropdown-header" data-testid="license-actions-group-licenses">Licenses</h6>
                                <button *ngIf="row.license" ngbDropdownItem type="button"
                                        class="text-danger"
                                        (click)="openDeactivate(row)"
                                        data-testid="license-deactivate-btn">Deactivate</button>
                                <button *ngIf="isDeactivated(row)" ngbDropdownItem type="button"
                                        (click)="openEditReason(row)"
                                        data-testid="license-edit-reason-btn">Edit reason</button>
                                <!-- UNIVAPLAT-2773: Reactivate keeps the shared confirm
                                     dialog directive flow from inside the menu item. -->
                                <button *ngIf="isDeactivated(row)" ngbDropdownItem type="button"
                                        class="text-success"
                                        confirmModal="Reactivate license"
                                        [confirmMessage]="'The most recently deactivated license of ' + (row.firstName + ' ' + row.lastName).trim() + ' will be reactivated. Are you sure?'"
                                        confirmOk="Yes, reactivate"
                                        confirmCancel="No, close"
                                        (confirmedClick)="reactivateLicense(row)"
                                        data-testid="license-reactivate-btn">Reactivate</button>
                                <button ngbDropdownItem type="button"
                                        (click)="openHistory(row)"
                                        data-testid="license-history-btn">History</button>

                                <!-- UNIVAPLAT-2991: OTP settings group — hidden entirely for
                                     test users (row.isTest). Turn to static / Turn to dynamic
                                     are mutually exclusive on isOtpModeStatic(row) (a missing
                                     otpMode is treated as dynamic); History is always offered
                                     alongside whichever switch action applies. Turn to static
                                     opens its own modal (UNIVAPLAT-2992, code + reason form).
                                     Turn to dynamic (UNIVAPLAT-2993) needs no bespoke modal —
                                     it reuses the shared confirmModal directive directly on the
                                     menu item, same pattern as the Reactivate license item
                                     above. History is UNIVAPLAT-2994 — still a wiring stub. -->
                                <ng-container *ngIf="!row.isTest">
                                    <div class="dropdown-divider"></div>
                                    <h6 class="dropdown-header" data-testid="otp-actions-group-header">OTP settings</h6>
                                    <button *ngIf="!isOtpModeStatic(row)" ngbDropdownItem type="button"
                                            (click)="openTurnToStatic(row)"
                                            data-testid="otp-turn-to-static-btn">Turn to static</button>
                                    <button *ngIf="isOtpModeStatic(row)" ngbDropdownItem type="button"
                                            confirmModal="Turn to dynamic"
                                            [confirmMessage]="'The OTP mode of ' + (row.firstName + ' ' + row.lastName).trim() + ' will be turned back to dynamic. Are you sure?'"
                                            confirmOk="Yes, proceed"
                                            confirmCancel="No, cancel"
                                            confirmOkClass="btn-success"
                                            confirmCancelClass="btn-draft"
                                            (confirmedClick)="turnToDynamic(row)"
                                            data-testid="otp-turn-to-dynamic-btn">Turn to dynamic</button>
                                    <button ngbDropdownItem type="button"
                                            (click)="openOtpHistory(row)"
                                            data-testid="otp-history-btn">History</button>
                                </ng-container>
                            </div>
                        </div>
                    </div>
                </ng-template>
            </ngx-datatable-column>
        </ngx-datatable>
        </div>
    }

</div>
<div class="d-flex align-items-center justify-content-between px-3 mt-2 pagination-pill">
    <div class="size-segment">
        <span class="size-label px-2">Page selector</span>
        <button class="btn" [ngClass]="{'fw-bolder': pagination.size == 25}" (click)="setPaginationSize(25)">25</button>
        <button class="btn" [ngClass]="{'fw-bolder': pagination.size == 50}" (click)="setPaginationSize(50)">50</button>
        <button class="btn" [ngClass]="{'fw-bolder': pagination.size == 100}" (click)="setPaginationSize(100)">100</button>
    </div>
    <div class="pagination-info">
        <b>{{ pagination.totalCount }}</b> patients - Showing {{ pagination.fromRecord }}-{{ pagination.toRecord }}
    </div>
    <div>
        <button class="btn page-nav-btn me-2" [disabled]="pagination.currentPage <= 1" (click)="previousPage()">&lt; PREVIOUS PAGE</button>
        <button class="btn page-nav-btn" [disabled]="pagination.currentPage == pagination.totalPages" (click)="nextPage()">NEXT PAGE &gt;</button>
    </div>
</div>
